module.exports = __webpack_public_path__ + "img/copy-link.e479585e.svg";